import React from 'react'

import styled from '@emotion/styled/macro'

import { subLabelFontSize } from './basis'

const StyledSubDescription = styled.p<SubDescriptionProps<any>>`
  font-family: 'PT-Astra-Serif', serif;
  font-style: italic;
  font-weight: normal;
  text-decoration: none;
  font-size: ${props => props.fontSize};
  text-align: center;
  margin-top: 1pt;
`

type SubDescriptionProps<T> = {
  id?: T
  children: React.ReactNode
  fontSize?: string
}

export function SubDescription<T extends string | undefined>({
  fontSize = subLabelFontSize,
  ...rest
}: SubDescriptionProps<T>) {
  return <StyledSubDescription fontSize={fontSize} {...rest} />
}
